import { createFileRoute } from '@tanstack/react-router';
import { PartnerHomePage } from '@/pages/partner/home/PartnerHomePage';

export const Route = createFileRoute('/partner/')({
  component: PartnerHomePage
});
